module.exports = __webpack_public_path__ + "img/arrow_up_square.ff377680.svg";